import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const notifications = ["María de Buenos Aires acaba de comprar el Megapack Teacher's Resource", "Carolina de Córdoba acaba de comprar el Megapack Teacher's Resource", "Luciana de Rosario acaba de comprar el Megapack Teacher's Resource", "Valentina de Mendoza acaba de comprar el Megapack Teacher's Resource", "Sofía de La Plata acaba de comprar el Megapack Teacher's Resource", "Florencia de Tucumán acaba de comprar el Megapack Teacher's Resource", "Camila de Mar del Plata acaba de comprar el Megapack Teacher's Resource", "Agustina de Salta acaba de comprar el Megapack Teacher's Resource"];
export function SocialProofPopup() {
  const [currentNotification, setCurrentNotification] = useState<string | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showNotification = () => {
      const randomNotification = notifications[Math.floor(Math.random() * notifications.length)];
      setCurrentNotification(randomNotification);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Show for 4 seconds
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(showNotification, 5000);
    // Set up interval for subsequent popups (every 15-25 seconds)
    const interval = setInterval(() => {
      if (!isVisible) {
        showNotification();
      }
    }, Math.floor(Math.random() * 10000) + 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-281">
      {isVisible && currentNotification && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 500,
      damping: 30
    }} className="fixed bottom-4 left-4 z-50 max-w-xs sm:max-w-sm bg-white rounded-lg shadow-2xl border border-gray-100 p-4 flex items-start space-x-3" data-id="element-282">
          <div className="flex-shrink-0 mt-0.5" data-id="element-283">
            <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-284" />
          </div>
          <div data-id="element-285">
            <p className="text-sm font-medium text-gray-900 leading-snug" data-id="element-286">
              {currentNotification}
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-287">Hace unos minutos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}